export enum QuestionnaireQuestionType {
  FILE = "FILE",
  ITEM = "ITEM",
  LONG_TEXT = "LONG_TEXT",
  MULTI_SELECT = "MULTI_SELECT",
  SELECT = "SELECT",
  SHORT_TEXT = "SHORT_TEXT"
}
